import {Notification } from "element-ui";

const upload = {
    state: {
        url: ""
    },
    actions: {
        uploadFile(store, event) {
            // 获取上传的文件
            var file = event.target.files[0];
            if (file) {
                var data = new FormData();
                data.append("imagefile", file);
                var request = {
                    type: "upload",
                    data: data
                };
                store.dispatch("server", request).then((response)=>{
                    console.log(response.data)
                    if (response.data.status == 200) {
                        store.state.url = response.data.href;
                        Notification.success("上传文件成功!");
                    } else {
                        Notification.error("服务器响应失败!");
                    }
                });
            }
        }
    }
};

export default upload;



// WEBPACK FOOTER //
// ./src/store/modules/upload.js